// @ts-nocheck


import { EditTwoTone } from '@ant-design/icons';
import React, { Component } from 'react';
import styled from 'styled-components';
import notification from 'antd/lib/notification';
import { Link } from '../../lib/routerAdapter';
import moment from 'moment';


import { Popconfirm, Icon, ListTable } from './../../components/ui';
import { formatDateTimeToString } from './../../lib/helpers';
import { washingTypes, washingStatusTypes } from './../../lib/enum';
import { washingApi } from './../../lib/api';
import { notificationLoading } from './../../components/Notifications';

const StyledIcon = styled(Icon).withConfig({ displayName: "WashingList__StyledIcon", componentId: "sc-5gmanx-0" })(["cursor:pointer;"]);



const SyledAntIcon = styled(EditTwoTone).withConfig({ displayName: "WashingList__SyledAntIcon", componentId: "sc-5gmanx-1" })(["cursor:pointer;color:#2b7cff;margin-right:10px;"]);





const Operations = styled.div.withConfig({ displayName: "WashingList__Operations", componentId: "sc-5gmanx-2" })(["display:flex;align-items:center;justify-content:center;height:100%;"]);















class WashingList extends Component {
  state = {
    washings: []
  };

  async componentDidMount() {
    await this.fetchWashings();
  }

  fetchWashings = async () => {
    try {
      const vehicleId = parseInt(this.props.vehicleId, 10);
      const washings = await washingApi.fetchWashings(vehicleId);
      this.setState({
        washings: washings.data
      });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    }
  };

  onDelete = async (washing) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      const washingId = parseInt(washing.id, 10);
      if (!washingId) {
        throw new Error('Неверный идентификатор мойки');
      }
      await washingApi.deleteWashing(washingId);
      notification.success({
        message: `Мойка от ${formatDateTimeToString(washing)} успешно удалена`
      });
      await this.fetchWashings();
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  render() {
    const { enableDelete } = this.props;
    const { washings } = this.state;
    return (
      <ListTable
        columns={[
        {
          title: 'Планируемая дата',
          key: 'date',
          dataIndex: 'date',
          render: (date) => {
            const monthYear = moment.utc(date).format('MMMM YYYY года');
            return monthYear.charAt(0).toUpperCase() + monthYear.slice(1);
          }
        },
        {
          title: 'Дата выполнения',
          key: 'factDate',
          dataIndex: 'factDate',
          render: (value) =>
          value ? formatDateTimeToString(value, 'DD.MM.YYYY') : null
        },
        {
          title: 'Вид мойки',
          key: 'type',
          render: (type) => washingTypes[type]
        },
        {
          title: 'Статус',
          key: 'state',
          dataIndex: 'state',
          render: (state) => washingStatusTypes[state]
        },
        {
          width: '20px',
          renderRecord: (record) =>
          record && enableDelete ?
          <Operations>
                  <Link
              to={`/services/washings/${parseInt(record.id, 10)}/edit`}>

                    <SyledAntIcon />
                  </Link>
                  <Popconfirm
              placement="topRight"
              title="Вы действительно хотите удалить?"
              okText="Да"
              cancelText="Нет"
              onConfirm={() => this.onDelete(record)}>

                    <StyledIcon type="x" />
                  </Popconfirm>
                </Operations> :
          null
        }]
        }
        data={washings.sort(
          (a, b) => moment(b.date) - moment(a.date)
        )} />);


  }
}

export default WashingList;
